// import * as types from './SummaryBlock.actionTypes';

/**
 * Reducer
 * @param {*} state
 * @param {*} action
 */
const reducer = (state, action) => {
  try {
    const { type } = action;
    const newState = state;
    switch (type) {
      case '':
        break;

      default:
        // eslint-disable-next-line no-console
        console.error(`Unexpected action`);
        return state;
    }

    // console.log('newState', newState);
    return newState;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`reducer: ${e.stack}`);
  }
  return state;
};

export default reducer;
